import { render, staticRenderFns } from "./Beacons.vue?vue&type=template&id=1648f699&scoped=true"
import script from "./Beacons.vue?vue&type=script&lang=js"
export * from "./Beacons.vue?vue&type=script&lang=js"
import style0 from "./Beacons.vue?vue&type=style&index=0&id=1648f699&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1648f699",
  null
  
)

export default component.exports